import rheaPic from "@/public/images/artists/rhea.png";
import { Artist } from "@/types/types";

export const rhea = {
  id: "159",
  name: "Rhea",
  image: rheaPic,
  description: `Rhea's voice carries a smoky grit with a rich tone that exudes confidence and attitude. There's a raw, unapologetic texture to her vocals, combining a sultry warmth with sharp, punchy delivery. She effortlessly blends smooth, melodic phrases with a distinct, raspy edge, giving her sound a dynamic and bold presence`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Frhea-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: [
        "Soul",
        "Rock",
        "Dance",
        "RnB",
        "Afrobeat",
        "Unprocessed",
        "Belting",
        "Deep",
      ],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 57,
        high: 73,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
